import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API from "../../API/Api";

// IMAGES
import blue_violet from "../../assets/newcollection/blue-violet.avif";
import glasses from "../../assets/newcollection/glasses.avif";
import kids from "../../assets/newcollection/kids-glasses.avif";
import sunglasses from "../../assets/newcollection/sunglasses.avif";
import transition from "../../assets/newcollection/transition.avif";
import progressive from "../../assets/newcollection/progressive.avif";

const ExploreCollection = () => {
  const [allProducts, setAllProducts] = useState([]);
  const [collections, setCollections] = useState([]);

  const getAllProducts = async () => {
    try {
      const res = await API.get("/getAllProduct");
      const products = res.data.products || [];

      // CATEGORY IDs
      const GLASSES = "69157332eeb23fa59c7d5326";
      const SUNGLASSES = "6915705d9ceac0cdda41c83f";

      const Transition = "69157665eeb23fa59c7d5349";
      const Blue_Violet = "69157694eeb23fa59c7d5350";
      const Progressive = "691576ddeeb23fa59c7d5357";
      const Kids = "69157748eeb23fa59c7d5378";
      const Kids2 = "6915763ceeb23fa59c7d5342";

      // BUILD COLLECTIONS
      const collectionData = [
        {
          title: "Glasses",
          slug: "glasses",
          image: glasses,
          products: products.filter((p) => p.cat_id === GLASSES),
        },
        {
          title: "Sunglasses",
          slug: "sunglasses",
          image: sunglasses,
          products: products.filter((p) => p.cat_id === SUNGLASSES),
        },
        {
          title: "Transitions",
          slug: "transitions",
          image: transition,
          products: products.filter(
            (p) => p.subCat_id === Transition),
        },
        {
          title: "Blue Violet",
          slug: "blue-violet",
          image: blue_violet,
          products: products.filter(
            (p) => p.subCat_id === Blue_Violet),
        },
        {
          title: "Progressive",
          slug: "progressive",
          image: progressive,
          products: products.filter(
            (p) => p.subCat_id === Progressive),
        },
        {
          title: "Kids",
          slug: "kids",
          image: kids,
          products: products.filter(
            (p) => p.subCat_id === Kids || p.subCat_id === Kids2
          ),
        },
      ];

      setCollections(collectionData);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getAllProducts();
  }, []);

  return (
    <section className="py-16 md:px-26 px-6 bg-white text-center">
      <h2 className="text-3xl font-bold mb-2">
        Our <span className="text-[#f00000]">Collections</span>
      </h2>
      <hr className="w-60 mx-auto mb-2 border-black" />
      <p className="text-gray-700 mb-10 font-semibold">
        Hand-picked styles for every vision and personality.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 hover:cursor-pointer">
        {collections.map((item, index) => (
          <Link
            key={index}
            to={`/collectionProducts/${item.slug}`}
            state={{ products: item.products }}
          >
            <div className="group relative overflow-hidden rounded-xl shadow hover:shadow-lg transition-all">
              <img
                src={item.image}
                alt={item.title}
                loading="lazy"
                className="w-full h-78 object-cover transform group-hover:scale-105 transition duration-300"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-[#f00000] bg-opacity-50 text-white py-3 text-lg font-semibold">
                {item.title}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default ExploreCollection;
